import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import './user-list.css';
import _ from 'lodash';
import ListPanel from '../../../components/list-panel/ListPanel';
import Toggle from 'react-toggle';
import TimeAgo from '../../../../node_modules/react-timeago/lib/index';
import MultiStepModal from '../../../components/multi-step-modal/MultiStepModal';
import InputField from '../../../components/input-field/InputField';
import ValidationService from '../../../services/ValidationService';
import Dropdown from '../../../components/dropdown/Dropdown';
import RESTService from '../../../services/RESTService';
import CommonService from '../../../services/CommonService';
import RoutingService from '../../../services/RoutingService';
import AuthService from '../../../services/AuthService';
import AddTenantModal from '../add-tenant-modal/AddTenantModal';
import Spinner from '../../../components/spinner/Spinner';
import DialogModal from '../../../components/dialog-modal/DialogModal';
const VS = new ValidationService();
const connect = new RESTService();
const CS = new CommonService();
const RS = new RoutingService();
const auth = new AuthService();

class UserList extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			users: [],
			firstName: '',
			lastName: '',
			email: '',
			selectedTenants: [],
			roles: [],
			roleMap: [],
			tenants: [],
			tenantMap: {},
			tenantRoleMap: {},
			userMap: {},
			platformAdminChecked: false,
			platformManagerChecked: false,
			expandedCmp: null,
			userToEdit: null,
			cmpOpen: false,
			searchText: '',
			showManageUser: false,
			showAddTenant: false,
			loading: true
		};
		this.autoBindAll(this);
	}

	componentDidMount() {
		connect
			.getMyUsers()
			.then(res => {
				this.observe(() => {
					if (auth.hasPlatformRole()) {
						this.data.users = res.data;
					} else {
						let usrs = [];
						_.forEach(res.data, user => {
							if (user.tenantRoles) {
								let uTs = Object.keys(user.tenantRoles);
								if (uTs.indexOf(RS.getCurrentTenant()) >= 0) {
									if (!user.platformRoles) {
										let myRoles = auth.getTenantRoles();
										if (myRoles) {
											let tenants = Object.keys(myRoles);
											let visible = {};
											_.forEach(tenants, tenant => {
												if (uTs.indexOf(tenant) >= 0) {
													visible[tenant] = user.tenantRoles[tenant];
												}
											});
											user.tenantRoles = visible;
											usrs.push(user);
										}
									}
								}
							}
						});
						this.data.users = usrs;
					}
					this.data.userMap = CS.mapByParam('_id', this.data.users);
					this.data.loading = false;
				});
			})
			.catch(err => {
				RS.smartError(err);
			});
		connect
			.getTenants()
			.then(res => {
				this.observe(() => {
					this.data.tenants = res.data;
					this.data.tenantMap = CS.mapByParam('_id', res.data);
				});
			})
			.catch(err => {
				RS.smartError(err);
			});
		connect
			.getAllRoles()
			.then(res => {
				this.observe(() => {
					this.data.roles = res.data;
					this.data.roleMap = CS.mapByParam('name', res.data);
				});
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	onCloseAddTenant() {
		this.setData('showAddTenant', false);
	}

	onEditUser(evt) {
		let user = evt.currentTarget.dataset.user;
		let role = evt.currentTarget.dataset.role;
		if (user) {
			this.observe(() => {
				this.data.showAddTenant = true;
				this.data.userToEdit = this.data.userMap[user];
				this.data.roleForTenant = role;
			});
		}
	}

	removeTenant(evt) {
		let user = evt.currentTarget.dataset.user;
		let role = evt.currentTarget.dataset.role;
		let tenant = evt.currentTarget.dataset.tenant;
		if (user && role && tenant) {
			this.observe(() => {
				this.data.showConfirmDelete = true;
				this.data.userToEdit = this.data.userMap[user];
				this.data.roleForTenant = role;
				this.data.tenantToRemove = tenant;
			});
		}
	}

	confirmDelete() {
		let { userToEdit, tenantToRemove } = this.data;
		delete userToEdit.tenantRoles[tenantToRemove];
		connect
			.updateUser(userToEdit)
			.then(() => {
				RS.showSuccess();
				this.onCloseDelete();
				this.componentDidMount();
			})
			.catch(err => {
				RS.smartError(err);
				this.onCloseDelete();
				this.componentDidMount();
			});
	}

	onCloseDelete() {
		this.setData('showConfirmDelete', false);
	}

	onEditComplete() {
		this.onCloseAddTenant();
		this.componentDidMount();
	}

	onSearchChange(evt) {
		this.setData('searchText', evt.target.value);
	}

	onInvite() {
		this.setData('showManageUser', !this.data.showManageUser);
	}

	onBasicChange(evt) {
		if (this.data[evt.target.name] !== null) {
			this.observe(() => {
				this.data[evt.target.name] = evt.target.value.trim();
			});
		}
	}

	validateStep1() {
		let { firstName, lastName, email } = this.data;
		if (firstName.length > 0 && lastName.length > 0 && VS.validateEmail(email)) {
			return true;
		}
		return false;
	}

	onTenantsChange(newVal) {
		this.observe(() => {
			this.data.selectedTenants = newVal;
			let rm = this.data.tenantRoleMap;
			let newMap = {};
			_.forEach(newVal, opt => {
				if (rm[opt.value]) {
					newMap[opt.value] = rm[opt.value];
				}
			});
			this.data.tenantRoleMap = newMap;
		});
	}

	getTenants() {
		let options = [];
		let validTenants = auth.getAvailableTenants();
		_.forEach(this.data.tenants, t => {
			if (auth.hasPlatformRole() || validTenants.indexOf(t.name) >= 0) {
				options.push({ label: t.name, value: t._id });
			}
		});
		return options;
	}

	onRoleChange(newVal) {
		this.observe(() => {
			this.data.tenantRoleMap[newVal.tenant] = newVal.value;
		});
	}

	onSendInvite() {
		let invite = {
			displayName: `${this.data.firstName} ${this.data.lastName}`,
			email: this.data.email
		};
		if (this.data.platformAdminChecked) {
			invite.platformRoles = 'platform-admin';
		}
		if (this.data.platformManagerChecked) {
			invite.platformRoles = 'platform-manager';
		}
		if (!invite.platformRoles) {
			let tMap = {};
			_.forEach(Object.keys(this.data.tenantRoleMap), tId => {
				let t = this.data.tenantMap[tId];
				if (t && t.name) {
					tMap[t.name] = [this.data.tenantRoleMap[tId]];
				}
			});
			invite.tenantRoles = tMap;
		}
		connect
			.sendInvite(invite)
			.then(() => {
				RS.showSuccess();
				this.observe(() => {
					this.data.firstName = '';
					this.data.lastName = '';
					this.data.email = '';
					this.data.selectedTenants = [];
					this.data.showManageUser = false;
				});
				this.componentDidMount();
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	buildAvailableRoles(t) {
		//Return all roles if platform user or only return non platform roles if tenant user
		let opts = [];
		_.forEach(this.data.roles, role => {
			if (auth.getRole().indexOf('platform-') >= 0) {
				opts.push({
					label: role.displayName,
					value: role.name,
					tenant: t._id
				});
			} else if (auth.getRole().indexOf('platform-') < 0 && role.name.indexOf('platform-') < 0) {
				opts.push({
					label: role.displayName,
					value: role.name,
					tenant: t._id
				});
			}
		});
		return opts;
	}

	buildRoleList() {
		let list = [];
		_.forEach(this.data.selectedTenants, item => {
			let t = this.data.tenantMap[item.value];
			if (t) {
				list.push(
					<div className="m-list-item hbox vcenter" key={t._id + '-m-list-item'}>
						<div className="tenant-name">{t.name}</div>
						<Dropdown
							value={this.data.tenantRoleMap[t._id]}
							placeholder="Select a role"
							handleChange={this.onRoleChange}
							name="rolePicker"
							options={this.buildAvailableRoles(t)}
						/>
					</div>
				);
			}
		});
		return (
			<div className="step-3-content">
				<div className="m-list-header hbox vcenter">
					<div className="label tenant">Tenant</div>
					<div className="label role">Role</div>
				</div>
				<div className="role-list vbox">{list}</div>
			</div>
		);
	}

	onToggle(evt) {
		if (evt.target.dataset.name === 'platformAdminChecked') {
			this.observe(() => {
				this.data.platformAdminChecked = evt.target.checked;
				this.data.platformManagerChecked = false;
			});
		} else {
			this.observe(() => {
				this.data.platformAdminChecked = false;
				this.data.platformManagerChecked = evt.target.checked;
			});
		}
	}

	getSteps() {
		let { firstName, lastName, email, selectedTenants, platformAdminChecked, platformManagerChecked } = this.data;
		return {
			'User Details': {
				validator: this.validateStep1,
				onNext: null,
				text: "Let's start with the basic details.",
				nextText: 'Next',
				content: (
					<div className="vbox w-100">
						<InputField
							label="First Name"
							name="firstName"
							type="text"
							className="w-100"
							value={firstName}
							handleChange={this.onBasicChange}
							placeholder="Enter a first name"
							required
						/>
						<InputField
							label="Last Name"
							className="w-100"
							name="lastName"
							type="text"
							value={lastName}
							handleChange={this.onBasicChange}
							placeholder="Enter a last name"
							required
						/>
						<InputField
							label="Email"
							name="email"
							className="w-100"
							type="text"
							value={email}
							handleChange={this.onBasicChange}
							placeholder="Enter an email"
							required
						/>
					</div>
				)
			},
			Tenants: {
				validator: () => {
					return this.data.selectedTenants.length > 0 || this.data.platformManagerChecked || this.data.platformAdminChecked;
				},
				onNext: null,
				text: `What tenants would you like ${firstName} to have access to?`,
				nextText: 'Next',
				content: (
					<div>
						<Dropdown
							className="w-100"
							label="Tenants"
							value={selectedTenants}
							placeholder="Select tenants"
							tagPicker={true}
							handleChange={this.onTenantsChange}
							name="tenantPicker"
							options={this.getTenants()}
							disabled={platformManagerChecked || platformAdminChecked}
						/>
						{(auth.isPlatformAdmin() || auth.isPlatformManager()) && (
							<div className="platform-options vbox vcenter hcenter">
								<div className="or-line">Or are they one of the following?</div>
								{auth.isPlatformAdmin() && (
									<div className="platform-row hbox vcenter">
										<div className="label">Platform Administrator</div>
										<Toggle onChange={this.onToggle} checked={platformAdminChecked} data-name={'platformAdminChecked'} />
									</div>
								)}
								{(auth.isPlatformAdmin() || auth.isPlatformManager()) && (
									<div className="platform-row hbox vcenter">
										<div className="label">Platform Manager</div>
										<Toggle onChange={this.onToggle} checked={platformManagerChecked} data-name={'platformManagerChecked'} />
									</div>
								)}
							</div>
						)}
					</div>
				)
			},
			Roles: {
				validator: () => {
					return Object.keys(this.data.tenantRoleMap).length === Object.keys(this.data.selectedTenants).length;
				},
				onNext: this.onSendInvite,
				text: auth.hasPlatformRole() ? 'This user will have the platform role on all tenants.' : `What is ${firstName}'s role in each tenant?`,
				nextText: 'Finish',
				content: auth.hasPlatformRole() ? <div className="or-line">Click finish to complete the invite to {firstName}.</div> : this.buildRoleList()
			}
		};
	}

	onUserClick(evt) {
		let clsList = evt.target.classList;
		if (clsList.contains('action') || (clsList.contains('mdi') && !clsList.contains('mdi-chevron-down') && !clsList.contains('mdi-chevron-up'))) {
			return;
		}
		let key = evt.currentTarget.dataset.id;
		if (key && this.data.expandedCmp !== key) {
			this.observe(() => {
				this.data.expandedCmp = key;
				this.data.cmpOpen = '';
			});
			setTimeout(() => {
				this.setData('cmpOpen', 'open');
			}, 100);
		} else if (key) {
			this.setData('cmpOpen', 'close');
			setTimeout(() => {
				this.observe(() => {
					this.data.expandedCmp = null;
					this.data.cmpOpen = '';
				});
			}, 200);
		}
	}

	getRoleTenants(user, role) {
		if (user.platformRoles && user.platformRoles.length > 0) {
			return 'All';
		}
		let items = [];
		if (user.tenantRoles) {
			let tenants = Object.keys(user.tenantRoles);
			_.forEach(tenants, tenant => {
				let roles = user.tenantRoles[tenant];
				if (roles.indexOf(role) >= 0) {
					items.push(
						<button className="btn small white hbox vcenter hcenter" key={`rmv-btn-${role}-${tenant}`}>
							{tenant} <i className="mdi mdi-close" data-user={user._id} data-role={role} data-tenant={tenant} onClick={this.removeTenant} />
						</button>
					);
				} else {
					items.push(<div key={tenant + '-na-key'}>N/A</div>);
				}
			});
		}
		return items;
	}

	buildRoleItems(user) {
		let items = [];
		_.forEach(this.data.roles, role => {
			if (!user.platformRoles && role.name.indexOf('platform-') < 0) {
				items.push(
					<div className="role-item hbox vcenter" key={`role-item-key-${user._id}-${role.name}`}>
						<div className="role grow-1">{role.displayName}</div>
						<button
							className="btn small square white vbox vcenter hcenter"
							data-rh="Add Tenant"
							data-rh-at="top"
							data-user={user._id}
							data-role={role.name}
							onClick={this.onEditUser}
						>
							<i className="mdi mdi-plus" />
						</button>
						<div className="tenants grow-1 hbox vcenter">{this.getRoleTenants(user, role.name)}</div>
					</div>
				);
			}
		});
		return items;
	}

	getExpandedCmp(id) {
		if (this.data.expandedCmp === id) {
			let user = this.data.userMap[id];
			if (user.platformRoles && user.platformRoles.length > 0) {
				let role = this.data.roleMap[user.platformRoles];
				return (
					<div className={`user-details ${this.data.cmpOpen}`} key={'details-key-' + id}>
						<div className="role-header hbox vcenter">
							<div className="label grow-1">Role</div>
							<div className="label grow-1">Tenant</div>
						</div>
						<div className="role-item hbox vcenter">
							<div className="role grow-1">{role.displayName}</div>
							<div className="tenants grow-1 hbox vcenter">ALL</div>
						</div>
					</div>
				);
			}
			return (
				<div className={`user-details ${this.data.cmpOpen}`} key={'details-key-' + id}>
					<div className="role-header hbox vcenter">
						<div className="label grow-1">Role</div>
						<div className="label grow-1">Tenant</div>
					</div>
					{this.buildRoleItems(user)}
				</div>
			);
		}
		return '';
	}

	buildUserItems() {
		if (this.data.loading) {
			return <Spinner text="Loading..." />;
		}
		let items = [];
		_.forEach(this.data.users, user => {
			if (user.displayName.toLowerCase().indexOf(this.data.searchText.toLowerCase()) >= 0) {
				items.push([
					<div className="list-item hbox vcenter" key={user._id + '-list-item'} data-id={user._id} onClick={this.onUserClick}>
						<div className="list-value ellipse grow-1">{user.displayName}</div>
						<div className="list-value ellipse grow-1">{user.email}</div>
						<div className="list-value ellipse grow-1">
							<TimeAgo date={user.lastSeen} />
						</div>
						<div className="actions hbox vcenter grow-1">
							{/*<div className="action vbox hcenter vcenter" data-rh="Edit User" data-rh-at="top" data-id={user._id} onClick={this.onEdit}>*/}
							{/*<i className="mdi mdi-pencil" data-id={user._id} />*/}
							{/*</div>*/}
							<i className={`mdi mdi-chevron-${this.data.expandedCmp && user._id === this.data.expandedCmp ? 'up' : 'down'}`} />
						</div>
					</div>,
					this.getExpandedCmp(user._id)
				]);
			}
		});
		return items;
	}

	render() {
		let { searchText, showManageUser, showAddTenant, tenants, userToEdit, roleForTenant, showConfirmDelete } = this.data;
		return (
			<div className="user-list-cmp animated fadeIn">
				<div className="user-list-header hbox vcenter hright">
					<div className="sub-title grow-1">Invite new users or modify existing ones.</div>
					<div className="search-ctn hbox vcenter">
						<i className="mdi mdi-magnify" />
						<input className="search-input" value={searchText} onChange={this.onSearchChange} placeholder="Search Users..." />
					</div>
				</div>
				<ListPanel
					name="Users List"
					className="user-list-panel"
					labels={['name', 'email', 'last active', 'actions']}
					onCreate={this.onInvite}
					listItems={this.buildUserItems()}
				/>
				<AddTenantModal
					isOpen={showAddTenant && userToEdit ? true : false}
					tenants={tenants}
					user={userToEdit}
					role={roleForTenant}
					onCancel={this.onCloseAddTenant}
					onComplete={this.onEditComplete}
				/>
				<MultiStepModal
					isOpen={showManageUser}
					onClose={this.onInvite}
					className="invite-user-modal"
					title={'Invite User'}
					steps={this.getSteps(this.data)}
				/>
				<DialogModal
					isOpen={showConfirmDelete}
					type="warning"
					title="Are you sure?"
					text="The user will no longer have access to this tenant."
					onCancel={this.onCloseDelete}
					onConfirm={this.confirmDelete}
					showCancelButton
				/>
			</div>
		);
	}
}

export default UserList;



// WEBPACK FOOTER //
// ./src/views/user-management/user-list/UserList.js